import { render } from "./NoTeleport.vue?vue&type=template&id=c10bd246"
import script from "./NoTeleport.vue?vue&type=script&lang=js"
export * from "./NoTeleport.vue?vue&type=script&lang=js"

import "./NoTeleport.vue?vue&type=style&index=0&id=c10bd246&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__